module.exports = __webpack_public_path__ + "static/img/277_TO8_2412.d80ed26.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/277_TO8_2412.jpg
// module id = C1nc
// module chunks = 0